<app-header [showHamburger]="visibleTabs().length > 1 && mediaService.isMobile()" (hamburgerClicked)="menu.toggle()"></app-header>

@if (debug.isDebugVisible()) {
  <app-debug-panel></app-debug-panel>
}

@let canCollapseText = !mediaService.isMobile() && collapsedSidenavToIcons();

<mat-sidenav-container autosize>
  <mat-sidenav
    #menu
    [mode]="mediaService.isMobile() ? 'over' : 'side'"
    [fixedInViewport]="mediaService.isMobile()"
    fixedTopGap="56"
    [opened]="!mediaService.isMobile()"
    [class.hidden]="visibleTabs().length === 0"
  >
    <mat-nav-list [class.collapsed]="canCollapseText">
      @for (tab of visibleTabs(); track tab) {
        <a
          mat-list-item
          (click)="setActiveTab(tab)"
          #link="routerLinkActive"
          [attr.data-testid]="tab.path"
          [target]="tab.target"
          [routerLinkActive]="'active-route'"
          [routerLink]="[tab.prefix, tab.path]"
          [disableRipple]="true"
        >
          <span
            class="flex items-center gap-2 route-label"
            [matTooltip]="collapsedSidenavToIcons() ? tab.title : ''"
            [matTooltipPosition]="'right'"
          >
            <mat-icon>{{ tab.icon }}</mat-icon>

            @if (!collapsedSidenavToIcons() || mediaService.isMobile()) {
              {{ tab.title }}
            }
          </span>
        </a>
      }
    </mat-nav-list>

    @if (!mediaService.isMobile()) {
      <div class="pl-3 mt-2 absolute bottom-2 left-0 right-0">
        <app-pan-button
          size="sm"
          [icon]="collapsedSidenavToIcons() ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left'"
          (click)="collapsedSidenavToIcons.set(!collapsedSidenavToIcons())"
        ></app-pan-button>
      </div>
    }
  </mat-sidenav>

  <mat-sidenav-content>
    <div id="customerio-alert"></div>

    @if (hasLoaded()) {
      @if (!userService.currentUserAcceptedTOS()) {
        <div class="flex justify-center items-center mt-10">
          <app-pan-card>
            <div class="p-6 max-w-lg">
              <h2 class="text-2xl font-bold mb-4">Terms of Service Update</h2>

              <p class="mb-4">
                We have updated our
                <a class="text-primary" href="https://panoptyc.com/terms-of-service/" target="_blank">Terms of Service</a>. Please review
                and accept the updated terms to continue using Panoptyc.
              </p>

              <div class="flex justify-end gap-4">
                <app-pan-button (click)="userService.logout()">Logout</app-pan-button>
                <app-pan-button color="primary" (click)="userService.acceptTOS()" data-testid="accept-tos-button"
                  >Accept Terms of Service</app-pan-button
                >
              </div>
            </div>
          </app-pan-card>
        </div>
      } @else {
        @if (isIncompleteUser() && !userService.currentUserIsGuest()) {
          <app-pan-inline-alert type="danger">
            We did not find any records tied to your account. Please contact Panoptyc support at
            <a class="font-bold underline" href="mailto:support@panoptyc.com">support&#64;panoptyc.com</a> to set up your account.
          </app-pan-inline-alert>
        }

        @if (!isIncompleteUser() || userService.currentUserIsGuest()) {
          <div class="mb-20 pb-20 app-container overflow-y-auto">
            <router-outlet></router-outlet>
          </div>
        }
      }
    }
  </mat-sidenav-content>
</mat-sidenav-container>
